<template>
    <div class="evaluatePage">
        <van-nav-bar title="满意度评价" left-arrow @click-left="backChange1" />
        <div class="evaluatecontent">
            <div class="evaluateItem" v-for="(item, index) in dataSources" :key="index">
                <div class="evaluateTitle">
                    <span>{{ item.lecturer_name }}</span>
                    <dd>老师</dd>
                </div>
                <div class="evaluateDes">
                    满意度评价
                </div>
                <div class="evaluateStart">
                    <van-rate v-model=item.score :size="25" color="#FFB30A" void-icon="star"  :readonly="isEdit==0"  void-color="#F1F1F1" />
                </div>
                <div class="evaluateDes topMargin">
                    授课详情
                </div>
                <div class=courseDetailItem v-for="(courseName, indexs) in item.course_list" :key="indexs">
                    <span>授课课程名称：</span>
                    <dd>{{ courseName }}</dd>
                </div>
            </div>
        </div>
        <div v-if="isEdit==1" class="postBtn" @click="postAction">
            提交
        </div>

    </div>
</template>
<script>

export default {
    name: 'evaluatePage',
    data() {
        return {
            value: 0,
            activity_id: this.$route.query.activity_id ? this.$route.query.activity_id : '',
            dataSources: {},
            isEdit: this.$route.query.isEdit ? this.$route.query.isEdit : 0,

        };
    },
    mounted() {
        this.getData();
    },
    created() {
    },
    methods: {
        async postAction() {
            let params = {
                activity_id: this.$route.query.activity_id,
            };
     
            let isSource = false;    
            this.dataSources.forEach((item) => {
                 if(item.score > 0){
                    isSource = true;
                    return;
                }
            });
            if(isSource === false){
                this.$toast('请对老师进行评价');
                return;
            }
            let data =[];
            this.dataSources.forEach((item) => {
                data.push({
                    lecturer_name: item.lecturer_name,
                    score: String(item.score)
                });
            });
            const res = await this.$api.learningPage.evaluate(params,data);
            if (res.success) {
                this.$toast('提交成功');
                this.$router.go(-1);
            }
        },
        async getData() {
            let params = {
                activity_id: this.$route.query.activity_id
            };
            const res = await this.$api.learningPage.getEvaluate(params);
            if (res.success) {
                if (res.data.length > 0) {
                    res.data.forEach((item) => {
                        item.score = Number(item.score);
                    });
                }
                this.dataSources = res.data;
            }
        },
        backChange1() {
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped lang="less">
.postBtn {
    width: 686px;
    height: 88px;
    background: linear-gradient(164deg, #5EC9FF 0%, #498BFD 100%);
    border-radius: 48px;
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
    position: fixed;
    bottom: 20px;
}

::v-deep {
    .van-nav-bar__title {
        font-size: 16px;
        color: #333333;
    }

    .van-nav-bar {
        width: 100%;
        margin-bottom: 32px;
    }
}
.evaluatecontent {
        padding: 32px;
        box-sizing: border-box;
        background: #F7F7F7;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 60px;
        padding-top: 0px;
    }
.evaluatePage {
    min-height: 100vh;
    padding-bottom: 100px;
    background: #F7F7F7;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
 

    .evaluateItem {
        width: 686px;
        min-height: 300px;
        background: #FFFFFF;
        border-radius: 16px;
        border: 1px solid #F0F0F0;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 32px 24px;
        box-sizing: border-box;

        .evaluateTitle {
            display: flex;
            align-items: center;
            height: 88px;
            border-bottom: 1px solid #F0F0F0;
            width: 100%;

            span {
                max-width: 550px;
                height: 32px;
                font-size: 32px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 32px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            dd {
                height: 24px;
                font-size: 24px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 24px;
                margin-left: 8px;
            }

        }

        .evaluateDes {
            margin-top: 32px;
            height: 24px;
            font-size: 24px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 24px;
            width: 100%;

        }

        .evaluateStart {
            margin-top: 24px;
            width: 100%;
            display: flex;

        }

        .topMargin {
            margin-top: 56px;
        }

        .courseDetailItem {
            width: 100%;
            min-height: 76px;
            background: #F7F7F7;
            border-radius: 8px;
            margin-top: 24px;
            display: flex;
            padding: 24px;
            box-sizing: border-box;

            span {
                width: 180px;
                height: 28px;
                font-size: 24px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 28px;

            }

            dd {
                min-height: 28px;
                width: 400px;
                font-size: 24px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 28px;


            }

        }


    }
}
</style>
